import { Button } from "@/shared/components/Button";
import { useModalContexto } from "@/shared/components/modalContexto";

interface BotaoVoltarProps {
  /** Usado em páginas (a proteção de saída age na navegação). Em janelas, quem manda é o `Modal`. */
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

/** "Voltar" do rodapé de Criar/Editar: sai sem fazer nada (e avisa se houver dados não salvos). */
export function BotaoVoltar({ onClick, disabled, className = "" }: BotaoVoltarProps) {
  const modal = useModalContexto();
  if (!modal && !onClick) return null;
  return (
    <Button
      type="button"
      onClick={modal ? modal.solicitarFechamento : onClick}
      disabled={disabled}
      className={`bg-surface-2 text-text hover:bg-border ${className}`}
    >
      Voltar
    </Button>
  );
}
